/**
 * Whether a failed profile load deserves the "Failed to load profile" dialog.
 *
 * Signing out from Profile changes the auth state while the screen is still
 * mounted, so the profile reloads once without a session and fails. That is
 * not an error the user should see on the login screen (founder QA,
 * 2026-10-16). A 401 means the session ended, which the auth layer already
 * handles by sending the user to sign in.
 */
export function shouldReportProfileLoadFailure(error: unknown, stillSignedIn: boolean): boolean {
  if (!stillSignedIn) return false;
  const failure = error as { response?: { status?: number }; status?: number } | null | undefined;
  const status = failure?.response?.status ?? failure?.status;
  return status !== 401;
}
